export default "__VITE_ASSET__CjzQg$mo__"